import { fabric } from 'fabric';
import get from 'lodash-es/get';
import truncate from 'lodash-es/truncate';

/**
 * Rich object class
 *
 */
const LudusRich = fabric.util.createClass(fabric.Group, {
  type: 'ludusRich',
  lockUniScaling: false,
  lockScalingFlip: true,
  minWidth: 100,
  minHeight: 100,
  thumbnailOnly: false,

  /**
   * Class constructor
   *
   * @param iconImage
   * @param thumbnailImage
   * @param logoImage
   * @param options
   */
  initialize(iconImage, thumbnailImage, logoImage, options = {}) {
    this.icon = iconImage ? iconImage.src : null;
    this.thumbnail = thumbnailImage ? thumbnailImage.src : null;
    this.logo = logoImage ? logoImage.src : null;
    this.initialized = false;
    this.callSuper('initialize', [], options);

    // In a few cases (only giphy for now) we don't want any icon or title - just
    // the full width/height thumbnail
    if (this.get('thumbnailOnly')) {
      this._addThumbnail(thumbnailImage);
    } else {
      this._addBackground();
      if (logoImage) {
        this._addLogo(logoImage);
      }
      if (thumbnailImage) {
        this._addThumbnail(thumbnailImage);
      } else if (options.title) {
        this._addTitle(options.title);
      }
      this._addIcon(iconImage);
    }

    this._initConfig();

    this.initialized = true;
  },

  _initConfig() {
    // TO DO BETTER
    if (get(this, 'ludus.source') === 'sketchfab') {
      this.ludus = {
        autoplay: false,
        camera: true,
        autospin: false,
        transparent: false,
        ...this.ludus,
      };
    }
    if (get(this, 'ludus.source') === 'typeform') {
      this.ludus = {
        backgroundOpacity: 100,
        hideHeaders: false,
        hideFooter: false,
        ...this.ludus,
      };
    }
    if (get(this, 'ludus.source') === 'codepen') {
      this.ludus = {
        controls: true,
        theme: 'light',
        defaultTab: 'result',
        applyScale: false,
        ...this.ludus,
      };
    }
    if (get(this, 'ludus.source') === 'maps') {
      this.ludus = {
        zoom: 15,
        mapType: 'roadmap',
        ...this.ludus,
      };
    }
  },

  _addBackground() {
    this.backgroundObject = new fabric.Rect({
      originX: 'center',
      originY: 'center',
      fill: 'rgba(245,245,245,0.5)',
      stroke: 'rgba(0,0,0,0.5)',
      strokeWidth: 1,
    });
    this.add(this.backgroundObject);
    this._positionBackground();
  },

  _addThumbnail(thumbnailImage) {
    this.thumbnailObject = new fabric.ImageAsync(thumbnailImage, {
      originY: 'center',
      originX: 'center',
    });
    this.add(this.thumbnailObject);
    this._positionThumbnail();
  },

  _addLogo(logoImage) {
    this.logoObject = new fabric.ImageAsync(logoImage, {
      originY: 'center',
      originX: 'center',
    });
    this.add(this.logoObject);
    this._positionLogo();
  },

  _addTitle(title) {
    this.titleObject = new fabric.Textbox(truncate(title, { length: 60 }), {
      editable: false,
      fontFamily: 'Roboto',
      fontSize: 32,
      fontStyle: 'normal',
      fontWeight: '400',
      originX: 'center',
      originY: 'center',
      textAlign: 'center',
      fill: '#000',
    });
    this.add(this.titleObject);
    this._positionTitle();
  },

  _addIcon(iconImage) {
    this.iconObject = new fabric.ImageAsync(iconImage, {});
    this._positionIcon();
    this.add(this.iconObject);
  },

  _positionBackground() {
    let fill = 'rgba(245,245,245,0.5)';
    if (this.ludus?.backgroundOpacity < 100) {
      fill = `rgba(245,245,245,${this.ludus.backgroundOpacity / 100 / 2})`;
    } else if (this.ludus.transparent) {
      fill = 'rgba(245,245,245,0.1)';
    }
    this.backgroundObject.set({
      width: this.get('width') * this._getScaleXInGroup() - 1,
      height: this.get('height') * this._getScaleYInGroup() - 1,
      top: 0,
      left: 0,
      scaleX: 1 / this._getScaleXInGroup(),
      scaleY: 1 / this._getScaleYInGroup(),
      fill,
    });
  },

  _positionThumbnail() {
    if (this.get('thumbnailOnly')) {
      const scaleForHeight =
        this.get('height') / this.thumbnailObject.get('height');
      const scaleForWidth =
        this.get('width') / this.thumbnailObject.get('width');

      this.thumbnailObject.set({
        left: 0,
        top: 0,
        scaleX: scaleForWidth,
        scaleY: scaleForHeight,
        opacity: this.ludus.transparent ? 0.5 : 1,
      });
    } else if (this._widthOrHeightBelow(300)) {
      this.remove(this.thumbnailObject);
    } else {
      this.addIfRemoved(this.thumbnailObject);
      const desiredHeight = this._getScaledHeightInGroup() - 150;
      const scaleForHeight = desiredHeight / this.thumbnailObject.get('height');

      const desiredWidth = this._getScaledWidthInGroup() - 150;
      const scaleForWidth = desiredWidth / this.thumbnailObject.get('width');

      const scaleXY = Math.min(scaleForHeight, scaleForWidth, 1);
      this.thumbnailObject.set({
        left: 0,
        top: 0,
        scaleX: scaleXY / this._getScaleXInGroup(),
        scaleY: scaleXY / this._getScaleYInGroup(),
        opacity: this.ludus.transparent ? 0.5 : 1,
      });
    }
  },

  _positionLogo() {
    if (this._widthOrHeightBelow(300)) {
      this.remove(this.logoObject);
    } else {
      this.addIfRemoved(this.logoObject);
      const desiredHeight = this._getScaledHeightInGroup() - 150;
      const scaleForHeight = desiredHeight / this.logoObject.get('height');

      const desiredWidth = this._getScaledWidthInGroup() - 150;
      const scaleForWidth = desiredWidth / this.logoObject.get('width');

      const scaleXY = Math.min(scaleForHeight, scaleForWidth, 1);

      this.logoObject.set({
        left: 0,
        top: -75 / this._getScaleYInGroup(),
        scaleX: scaleXY / this._getScaleXInGroup(),
        scaleY: scaleXY / this._getScaleYInGroup(),
      });
    }
  },

  _positionTitle() {
    if (this._widthOrHeightBelow(300)) {
      this.remove(this.titleObject);
    } else {
      this.addIfRemoved(this.titleObject);
      const titleTop = this._hasVisibleLogo() ? 100 : 0;

      const titleWidth = this._getScaledWidthInGroup() - 150;
      this.titleObject.set({
        left: 0,
        top: titleTop / this._getScaleYInGroup(),
        width: titleWidth,
        scaleX: 1 / this._getScaleXInGroup(),
        scaleY: 1 / this._getScaleYInGroup(),
      });
    }
  },

  _positionIcon() {
    if (this._widthOrHeightBelow(100)) {
      this.remove(this.iconObject);
    } else {
      this.addIfRemoved(this.iconObject);

      let left;
      let top;
      let originX;
      let originY;
      if (this._widthOrHeightBelow(300)) {
        originX = 'center';
        originY = 'center';
        left = 0;
        top = 0;
      } else {
        originX = 'left';
        originY = 'top';
        left = -(this.get('width') / 2) + 15 / this._getScaleXInGroup();
        top = -(this.get('height') / 2) + 15 / this._getScaleYInGroup();
      }

      this.iconObject.set({
        originX,
        originY,
        left,
        top,
        scaleX: 0.5 / this._getScaleXInGroup(),
        scaleY: 0.5 / this._getScaleYInGroup(),
      });
    }
  },

  _widthOrHeightBelow(value) {
    return (
      this._getScaledWidthInGroup() < value ||
      this._getScaledHeightInGroup() < value
    );
  },

  _hasVisibleLogo() {
    return !!this.logoObject;
  },

  _positionChildren() {
    if (this.backgroundObject) {
      this._positionBackground();
    }
    if (this.logoObject) {
      this._positionLogo();
    }
    if (this.thumbnailObject) {
      this._positionThumbnail();
    } else if (this.titleObject) {
      this._positionTitle();
    }
    if (this.iconObject) {
      this._positionIcon();
    }
  },

  _getScaleXInGroup() {
    return (this.group ? this.group.get('scaleX') : 1) * this.get('scaleX');
  },

  _getScaleYInGroup() {
    return (this.group ? this.group.get('scaleY') : 1) * this.get('scaleY');
  },

  _getScaledWidthInGroup() {
    return (this.group ? this.group.get('scaleX') : 1) * this.getScaledWidth();
  },

  _getScaledHeightInGroup() {
    return (this.group ? this.group.get('scaleY') : 1) * this.getScaledHeight();
  },

  addIfRemoved(object) {
    if (!object.group) {
      this.add(object);
    }

    return this;
  },

  /**
   * Override fabric.Group.toObject() to include the reference
   *
   * @returns {Object}
   */
  toObject(propertiesToInclude = []) {
    const extraProps = [
      'icon',
      'thumbnail',
      'logo',
      'title',
      'minWidth',
      'minHeight',
      'thumbnailOnly',
      'originalUrl',
      'label',
    ];
    const object = this.callSuper(
      'toObject',
      propertiesToInclude.concat(extraProps),
    );
    delete object.objects;

    return object;
  },

  render(ctx) {
    this._positionChildren();
    this.callSuper('render', ctx);
  },
});

LudusRich.fromObject = (object, callback) => {
  const options = fabric.util.object.clone(object, true);

  const { icon, thumbnail, logo } = options;
  if (callback) {
    const richMedia = new LudusRich(icon, thumbnail, logo, options);
    callback(richMedia);
  }
};

export default LudusRich;
